module.exports = __webpack_public_path__ + "img/partners-fintechhub.86a38835.png";